import React, { Fragment, useEffect, useState, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { academyusergetdetail, roleMenuList } from "../../../services/admin";

let history = [];

const TeacherSideBar = () => {
  let location = useLocation();
  const [menuitems, setMenuitems] = useState();
  const [menu, setMenu] = useState();
  const [elogo, setElogo] = useState("");

  // ✅ FIX: Ref for the custom Scrollbars component
  const scrollRef = useRef(null); 

  // Load menu from API on mount
  useEffect(() => {
    roleMenuList('5').then((response) => {
      const data = response.data;
      
      const updatedItems = data.Items.map(item => {
        // Ensure type is link for Dashboard and update path
        if (item.title === 'Dashboard') {
          item.type = 'link';
        }
        if (item.path === '/superadmin/dashboard') {
          item.path = '/teacher/dashboard';
        }
        
        // Update children
        if (item.children && item.children.length > 0) {
          item.children = item.children.map(child => {
            if (child.title === 'Dashboard') {
              child.type = 'link';
            }
            if (child.path === '/superadmin/dashboard') {
              child.path = '/teacher/dashboard';
            }
            return child;
          });
        }
        return item;
      });
      
      data.Items = updatedItems;
      setMenu([data]);
      setMenuitems([data]);

      // Activate menus initially, passing the state array
      setTimeout(() => {
        setSidemenu([data]); 
      }, 100);
    });
  }, []);

  // On route change
  useEffect(() => {
    history.push(location.pathname); 
    if (history.length > 2) {
      history.shift();
    }
    if (history[0] !== history[1]) {
      // Pass the menuitems state array to trigger activation and scroll
      setSidemenu(menuitems); 
    }
    
    let mainContent = document.querySelector(".main-content");
    if (mainContent) {
      mainContent.addEventListener("click", mainContentClickFn);
      return () => {
        mainContent.removeEventListener("click", mainContentClickFn);
      };
    }
  }, [location, menuitems]); // Added menuitems to ensure setSidemenu gets the latest state

  // Load user logo once
  useEffect(() => {
    academyusergetdetail(localStorage.getItem("UID")).then((res) => {
      if (res.status === true) {
        if (res.data.details.logo !== null) {
          setElogo(res.data.path + res.data.details.logo)
        }
      }
    })
    if (
      document.body.classList.contains("horizontalmenu") &&
      window.innerWidth >= 992
    ) {
      clearMenuActive();
    }
  }, []);

  // ✅ FIX: Dedicated useEffect to scroll after menuitems update
  useEffect(() => {
    if (menuitems && menuitems.length > 0) {
        requestAnimationFrame(() => {
            scrollToActiveMenuItem();
        });
    }
  }, [menuitems]);

  let menuIcontype;
  if (document.querySelector("body").classList.contains("horizontalmenu")) {
    menuIcontype = "hor-icon";
  } else {
    menuIcontype = "sidemenu-icon";
  }

  function mainContentClickFn() {
    if (
      document.body.classList.contains("horizontalmenu") &&
      window.innerWidth >= 992
    ) {
      clearMenuActive();
    }
  }

  // ✅ FIX: Robust setSidemenu function with Array check and null checks/path normalization
  function setSidemenu(items = menuitems) {
    if (!items) return;

    // Ensure menuData is an array to fix "forEach is not a function"
    let menuData = items;
    if (!Array.isArray(menuData)) {
        menuData = [menuData];
    }
    
    // Normalize current path: remove trailing slash if present
    let currentPath = location.pathname;
    if (currentPath.endsWith('/') && currentPath.length > 1) {
      currentPath = currentPath.slice(0, -1);
    }
    if (currentPath === "/teacher/dashboard/") {
        currentPath = "/teacher/dashboard";
    }

    menuData.forEach((mainlevel) => {
      if (!mainlevel?.Items) return;

      mainlevel.Items.forEach((item) => {
        item.active = false;
        item.selected = false;
        
        // Normalize item path and ensure it's a string
        let itemPath = item.path || '';
        if (itemPath.endsWith('/') && itemPath.length > 1) {
            itemPath = itemPath.slice(0, -1);
        }

        if (currentPath === itemPath) {
          item.active = true;
          item.selected = true;
        }

        if (item.children) {
          item.children.forEach((submenu) => {
            submenu.active = false;
            submenu.selected = false;
            
            // Normalize submenu path and ensure it's a string
            let submenuPath = submenu.path || '';
            if (submenuPath.endsWith('/') && submenuPath.length > 1) {
                submenuPath = submenuPath.slice(0, -1);
            }

            if (currentPath === submenuPath) {
              item.active = true;
              item.selected = true;
              submenu.active = true;
              submenu.selected = true;
            }

            if (submenu.children) {
              submenu.children.forEach((submenu1) => {
                submenu1.active = false;
                submenu1.selected = false;
                
                // Normalize submenu1 path and ensure it's a string
                let submenu1Path = submenu1.path || '';
                if (submenu1Path.endsWith('/') && submenu1Path.length > 1) {
                    submenu1Path = submenu1Path.slice(0, -1);
                }

                if (currentPath === submenu1Path) {
                  item.active = true;
                  item.selected = true;
                  submenu.active = true;
                  submenu.selected = true;
                  submenu1.active = true;
                  submenu1.selected = true;
                }
              });
            }
          });
        }
      });
    });

    setMenuitems((arr) => [...arr]);
  }
  
  function toggleSidemenu(item) {
    if (
      !document.body.classList.contains("horizontalmenu-hover") ||
      window.innerWidth < 992
    ) {
      if (!item.active) {
        menuitems?.filter((mainlevel) => {
          if (mainlevel.Items) {
            mainlevel.Items.filter((sublevel) => {
              sublevel.active = false;
              if (item === sublevel) {
                sublevel.active = true;
              }
              if (sublevel.children) {
                sublevel.children.filter((sublevel1) => {
                  sublevel1.active = false;
                  if (item === sublevel1) {
                    sublevel.active = true;
                    sublevel1.active = true;
                  }
                  if (sublevel1.children) {
                    sublevel1.children.filter((sublevel2) => {
                      sublevel2.active = false;
                      if (item === sublevel2) {
                        sublevel.active = true;
                        sublevel1.active = true;
                        sublevel2.active = true;
                      }
                      return sublevel2;
                    });
                  }
                  return sublevel1;
                });
              }
              return sublevel;
            });
          }
          return mainlevel;
        });
      } else {
        item.active = !item.active;
      }
      setMenuitems((arr) => [...arr]);
    }
  }
  
  function clearMenuActive() {
    menu?.filter((mainlevel) => {
      if (mainlevel.Items) {
        mainlevel.Items.filter((sublevel) => {
          sublevel.active = false;
          if (sublevel.children) {
            sublevel.children.filter((sublevel1) => {
              sublevel1.active = false;
              if (sublevel1.children) {
                sublevel1.children.filter((sublevel2) => {
                  sublevel2.active = false;
                  return sublevel2;
                });
              }
              return sublevel1;
            });
          }
          return sublevel;
        });
      }
      return mainlevel;
    });
    setMenuitems((arr) => [...arr]);
  }

  //Hover effect
  function Onhover() {
    const mainBody = document.querySelector(".main-body");
    if (mainBody && mainBody.classList.contains("main-sidebar-hide")) {
        mainBody.classList.add("main-sidebar-open");
    }
  }
  function Outhover() {
    const mainBody = document.querySelector(".main-body");
    if (mainBody) {
        mainBody.classList.remove("main-sidebar-open");
    }
  }

  function errorhandle(ev) {
    ev.target.src = require("../../../assets/images/logo/logo.png");
    ev.target.onerror = null;
  }

  // ✅ FIX: Scroll function using the react-custom-scrollbars API
  function scrollToActiveMenuItem() {
    if (!scrollRef.current) return;

    // Use scrollRef.current.view to get the DOM element that wraps the content 
    const sidebar = scrollRef.current.view; 
    
    if (!sidebar) return; 

    // Find the link that is currently active, handling both top-level and nested links
    const activeLink = sidebar.querySelector(".nav-link.active, .nav-sub-item.active .nav-sub-link");
    
    if (activeLink) {
        // Find the closest list item to scroll to
        const activeListItem = activeLink.closest('li.nav-item, li.nav-sub-item');
        const targetElement = activeListItem || activeLink;
        
        // Calculate the scroll position
        const elementOffsetTop = targetElement.offsetTop;
        const scrollOffset = elementOffsetTop - 50; 

        // Use the Scrollbars API to set the scroll position
        scrollRef.current.scrollTop(scrollOffset);
    }
  }

  return (
    <Fragment>
      <div
        className="sticky "
        style={{ marginBottom: "-64px" }}
      >
        <div className="main-menu main-sidebar main-sidebar-sticky side-menu">
          <div className="main-container-1 active main-sidebar-header">
            <Scrollbars
              options={{ removeTrackXWhenNotUsed: true }}
              className="hor-scroll"
              style={{ position: "absolute" }}
              ref={scrollRef} // ✅ Attach ref here
            >
              <div className="sidemenu-logo">
                <Link className="main-logo" to={"/teacher/dashboard"}>
                  <img
                    src={elogo}
                    className="header-brand-img desktop-logo"
                    alt={"logo1"}
                    onError={errorhandle}
                  />

                  <img
                  src={elogo}
                    className="header-brand-img icon-logo"
                    alt={"logo-2"}
                  />

                  <img
                    src={elogo}
                    className="header-brand-img desktop-logo theme-logo"
                    alt={"logo-3"}
                    onError={errorhandle}
                  />
                  <img
                  src={elogo}
                    className="header-brand-img icon-logo theme-logo"
                    alt={"logo-4"}
                  />
                </Link>
              </div>
              <div
                className="main-body-1 main-sidebar-body"
                onMouseOver={() => Onhover()}
                onMouseOut={() => Outhover()}
              >
                <div className="slide-left " >
                  <i className="fe fe-chevron-left"></i>
                </div>
                <ul className="menu-nav nav" style={{ marginLeft: "0px" }}>
                  {menuitems?.map((Item, itemi) => (
                    <Fragment key={itemi + Math.random() * 100}>
                      <li className="nav-header">
                        <span className="nav-label">{Item.menutitle}</span>
                      </li>
                      {Item.Items.map((menuItem, i) => (
                        <li
                          className={`nav-item ${menuItem.selected ? "active" : ""
                            }`}
                          key={i}
                        >
                          {menuItem.type === "sub" ? (
                            <a
                              className={"nav-link with-sub"}
                              onClick={(event) => {
                                event.preventDefault();
                                toggleSidemenu(menuItem);
                              }}
                              href="#!"
                            >
                              <span className="shape1"></span>
                              <span className="shape2"></span>
                              <i
                                className={`${menuItem.icon} ${menuIcontype} menu-icon`}
                              ></i>
                              <span className="sidemenu-label">
                                {menuItem.title}
                              </span>
                              {menuItem.badge ? (
                                <label className={menuItem.badge}>
                                  {menuItem.badgetxt}
                                </label>
                              ) : (
                                ""
                              )}
                              <div className="according-menu">
                                {menuItem.active ? (
                                  <i
                                    className={`${menuItem.background} fa angle fa-angle-down `}
                                  ></i>
                                ) : (
                                  <i
                                    className={`${menuItem.background} fa angle fa-angle-right `}
                                  ></i>
                                )}
                              </div>
                            </a>
                          ) : (
                            ""
                          )}

                          {menuItem.type === "link" ? (
                            <NavLink
                              to={menuItem.path + "/"}
                              className={`nav-link ${menuItem.selected ? " active" : ""
                                }`}
                            >
                              <span className="shape1"></span>
                              <span className="shape2"></span>
                              <i
                                className={`${menuItem.icon} ${menuIcontype} menu-icon`}
                              ></i>
                              <span className="sidemenu-label">
                                {menuItem.title}
                              </span>
                              {menuItem.badge ? (
                                <label className={menuItem.badge}>
                                  {menuItem.badgetxt}
                                </label>
                              ) : (
                                ""
                              )}
                            </NavLink>
                          ) : (
                            ""
                          )}
                          {menuItem.children ? (
                            <ul
                              className={`nav-sub ${menuItem.active ? "open" : ""
                                }`}
                              style={
                                menuItem.active
                                  ? { display: "block" }
                                  : { display: "none" }
                              }
                            >
                              {menuItem.children.map((childrenItem, index) => {
                                return (
                                  <li
                                    key={index}
                                    className={`nav-sub-item ${childrenItem.selected ? "active show" : ""
                                      }`}
                                  >
                                    {childrenItem.type === "sub" ? (
                                      <a
                                        className="nav-sub-link sub-with-sub"
                                        onClick={(event) => {
                                          event.preventDefault();
                                          toggleSidemenu(childrenItem);
                                        }}
                                        href="#!"
                                      >
                                        <span className="sidemenu-label">
                                          {childrenItem.title}
                                          {childrenItem.active}
                                        </span>
                                        {childrenItem.active ? (
                                          <i className="angle fa fa-angle-down"></i>
                                        ) : (
                                          <i
                                            className={`${menuItem.background} fa angle fa-angle-right `}
                                          ></i>
                                        )}
                                      </a>
                                    ) : (
                                      ""
                                    )}

                                    {childrenItem.type === "link" ? (
                                      <NavLink
                                        to={childrenItem.path + "/"}
                                        className="nav-sub-link"
                                      >
                                        {childrenItem.title}
                                      </NavLink>
                                    ) : (
                                      ""
                                    )}
                                    {childrenItem.children ? (
                                      <ul
                                        className="sub-nav-sub"
                                        style={
                                          childrenItem.active
                                            ? { display: "block" }
                                            : { display: "none" }
                                        }
                                      >
                                        {childrenItem.children.map(
                                          (childrenSubItem, key) => (
                                            <li
                                              className={`nav-sub-item ${childrenSubItem.selected
                                                ? " active"
                                                : ""
                                                }`}
                                              key={key}
                                            >
                                              {childrenSubItem.type ===
                                                "link" ? (
                                                <NavLink
                                                  to={
                                                    childrenSubItem.path + "/"
                                                  }
                                                  className="nav-sub-link"
                                                >
                                                  {childrenSubItem.title}
                                                </NavLink>
                                              ) : (
                                                ""
                                              )}

                                              {childrenSubItem.type ===
                                                "sub" ? (
                                                <Link
                                                  to="#"
                                                  className="nav-sub-item"
                                                  onClick={(event) => {
                                                    event.preventDefault();
                                                    toggleSidemenu(
                                                      childrenSubItem
                                                    );
                                                  }}
                                                >
                                                  <span className="sidemenu-label">
                                                    {childrenSubItem.title}
                                                  </span>
                                                  {childrenSubItem.active ? (
                                                    <i className="fa fa-angle-down"></i>
                                                  ) : (
                                                    <i className="fa fa-angle-right"></i>
                                                  )}
                                                </Link>
                                              ) : (
                                                ""
                                              )}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      ""
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          ) : (
                            ""
                          )}
                        </li>
                      ))}
                    </Fragment>
                  ))}
                </ul>
                <div className="slide-right" >
                  <i className="fe fe-chevron-right"></i>
                </div>
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
      <div className="jumps-prevent" style={{ paddingTop: "64px" }}></div>
    </Fragment>
  );
};

export default TeacherSideBar;